import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group-text" }
const _hoisted_7 = ["id", "isInvalid", "onBlur"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "alert alert-danger" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { class: "mt-4" }

import CountrySelect from "@/components/CountrySelect.vue";
import LanguageSelect from "@/components/LanguageSelect.vue";
import RadioField from "@/components/RadioField.vue";
import { useValidateProps } from "@/composables/fields";
import { isMobileReactive } from "@/helpers";
import { dbEnums } from "@/types/enums/dbEnums";
import { SelectOption } from "@/types/interfaces/field";
import { DraftJobSeekerDto } from "@api/draft-job-seeker-dto";
import { format } from "date-fns";
import { PropType, computed } from "vue";
import { useI18n } from "vue-i18n";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSeekerFormBasicFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftJobSeekerDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

const props = __props;

const fields = dbEnums.PersonFields;
const genderOptions = [
	{ text: t("genders.man"), value: dbEnums.Genders.Man },
	{ text: t("genders.woman"), value: dbEnums.Genders.Woman },
	{ text: t("genders.other"), value: dbEnums.Genders.Other },
	{ text: t("genders.unknown"), value: null },
] as SelectOption[];

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const socialSecuritySign = computed(() => {
	if (!formDataComputed.value.birthday) {
		return "";
	}
	const birthday = formDataComputed.value.birthday;
	if (birthday >= new Date(1800, 0, 1) && birthday <= new Date(1899, 11, 31)) {
		return "+";
	} else if (birthday >= new Date(1900, 0, 1) && birthday <= new Date(1999, 11, 31)) {
		return "-";
	} else if (birthday >= new Date(2000, 0, 1)) {
		return "A";
	} else {
		return "";
	}
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("jobSeekerForm.sectionHeaders.basicInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.JobSeekerBasicInfo)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.JobSeekerBasicInfo.fields
            }, {
              [_unref(fields).JobSeekerFirstName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.firstName"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.firstName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.firstName) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerSecondNames]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.secondNames"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.secondNames,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.secondNames) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerLastName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.lastName"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.lastName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.lastName) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerCommunicationLanguage]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.communicationLanguageId"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(LanguageSelect, {
                      valueSingle: formDataComputed.value.communicationLanguage,
                      "onUpdate:valueSingle": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.communicationLanguage) = $event)),
                      valueSingleId: formDataComputed.value.communicationLanguageId,
                      "onUpdate:valueSingleId": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.communicationLanguageId) = $event)),
                      communicationRole: _unref(dbEnums).PersonUserRoleIds.Kotoutuminen,
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["valueSingle", "valueSingleId", "communicationRole", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerElectronicCommunicationAllowed]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftJobSeekerData.isElectronicCommunicationAllowed",
                    alignContent: ""
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoCheckbox, {
                        modelValue: formDataComputed.value.isElectronicCommunicationAllowed,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.isElectronicCommunicationAllowed) = $event)),
                        for: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).JobSeekerDateOfBirth]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.birthday"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.birthday,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.birthday) = $event)),
                      allowEmpty: "",
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: 'max-width: 20rem',
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      forceUtcMidnight: ""
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerSocialNumber]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.socialSecurityEndPart"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    (formDataComputed.value.birthday)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(format)(formDataComputed.value.birthday!, "ddMMyy") + socialSecuritySign.value), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              style: {"max-width":"80px"},
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.socialSecurityEndPart) = $event)),
                              maxlength: "4",
                              id: elementId,
                              isInvalid: isInvalid,
                              onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                            }, null, 40, _hoisted_7), [
                              [_vModelText, formDataComputed.value.socialSecurityEndPart]
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)("jobSeekerForm.dateOfBirthMustBeGiven")), 1)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerGender]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.gender"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(RadioField, {
                      modelValue: formDataComputed.value.genderId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.genderId) = $event)),
                      inline: !_unref(isMobileReactive),
                      options: genderOptions,
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "inline", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerCitizenship]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftJobSeekerData.citizenshipId"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(CountrySelect, {
                        valueSingle: formDataComputed.value.citizenship,
                        "onUpdate:valueSingle": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.citizenship) = $event)),
                        valueSingleId: formDataComputed.value.citizenshipId,
                        "onUpdate:valueSingleId": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.citizenshipId) = $event)),
                        ajax: true,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        id: elementId,
                        lowercase: "",
                        isCitizenship: ""
                      }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur", "id"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).JobSeekerOccupation]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftJobSeekerData.occupation"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoInput, {
                        modelValue: formDataComputed.value.occupation,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.occupation) = $event)),
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).JobSeekerExtraInfo]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftJobSeekerData.extraInfo"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoTextArea, {
                        modelValue: formDataComputed.value.extraInfo,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formDataComputed.value.extraInfo) = $event)),
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).JobSeekerTranslatorNeed]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "isTranslatorNeeded",
                  infoidentifier: "personJobSeekerData.isTranslatorNeeded",
                  alignContent: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoCheckbox, {
                      modelValue: formDataComputed.value.isTranslatorNeeded,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formDataComputed.value.isTranslatorNeeded) = $event)),
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      isInvalid: isInvalid,
                      id: elementId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onBlur", "isInvalid", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).JobSeekerTranslatorNeedLanguages]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftJobSeekerData.translatorNeedLanguages",
                  infoidentifier: "draftJobSeekerData.translatorNeedLanguages"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(LanguageSelect, {
                      valueMulti: formDataComputed.value.translatorNeedLanguages,
                      "onUpdate:valueMulti": _cache[14] || (_cache[14] = ($event: any) => ((formDataComputed.value.translatorNeedLanguages) = $event)),
                      id: elementId
                    }, null, 8, ["valueMulti", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})